// components/ForgotPassword.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
// import { Mail, ArrowLeft } from 'react-feather';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const response = await fetch(
        "https://ambatturindustrialestate.com/api/accounts/forgot-password/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email }),
        }
      );

      if (response.ok) {
        setMessage("Password reset link has been sent to your email.");
      } else {
        setError("Failed to send reset link. Please check your email.");
      }
    } catch (error) {
      setError("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container-fluid vh-100 bg-light">
      <div className="row h-100 justify-content-center align-items-center">
        <div className="col-md-4 col-lg-4">
          <div className="card shadow">
            <div className="card-body p-5">
              <Link
                to="/login"
                className="text-decoration-none d-flex align-items-center mb-4"
              >
                {/* <ArrowLeft size={18} className="me-2" /> */}
                Back to Login
              </Link>

              <div className="text-center mb-4">
                <h2 className="card-title">Forgot Password</h2>
                <p className="text-muted">
                  Enter your email to reset your password
                </p>
              </div>

              {message && (
                <div className="alert alert-success" role="alert">
                  {message}
                </div>
              )}

              {error && (
                <div className="alert alert-danger" role="alert">
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <div className="input-group">
                    <span className="input-group-text">
                      {/* <Mail size={18} /> */}
                    </span>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="d-grid gap-2">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isLoading}
                  >
                    {isLoading ? "Sending..." : "Send Reset Link"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
